import { useQuery } from "@tanstack/react-query";

import { listScheduleNotes } from "@/adapters/api";
import { toNote } from "../utils/map.ts";

export function useScheduleNotes(constructionId: string | undefined) {
	return useQuery({
		queryKey: ["schedule-notes", constructionId],
		queryFn: async () => {
			// biome-ignore lint/style/noNonNullAssertion: guarded by `enabled`
			const response = await listScheduleNotes(constructionId!);
			return response.items.map(toNote);
		},
		enabled: !!constructionId,
		staleTime: 30_000,
	});
}
